import moment from "moment";
import { useEffect, useRef, useState } from "react";
// TODO: Replace with backend endpoint
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ExportUserEvents() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');

    const tableRef = useRef(null);

    const [events, setEvents] = useState<any[]>([]);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/stats/usage-event', requestOptionsPost)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setEvents(data);
            });
    }, []);

    return (
        <div>
                {/* TODO: Replace with backend endpoint for Excel export */}
                <button disabled>Export (Pendiente)</button>

                <table  ref={tableRef}>
                 <tbody>
                    <tr>
                        <th>{ t("Email") }</th>
                        <th>{ t("Action") }</th>
                        <th>{ t("Reference") }</th>
                        <th>{ t("Start") }</th>
                        <th>{ t("End") }</th>
                        <th>{ t("Start date") }</th>
                        <th>{ t("End date") }</th>
                        <th>{ t("Duration") }</th>
                    </tr>
                    { events.map((e: any) => {
                        return <tr>
                            <td>{ e.user }</td>
                            <td>{ e.action }</td>
                            <td>{ e.reference }</td>
                            <td>{ e.start }</td>
                            <td>{ e.end }</td>
                            <td>{ moment(e.start).format('YYYY-MM-DD hh:mm:ss') }</td>
                            <td>{ e.end && moment(e.end).format('YYYY-MM-DD hh:mm:ss') }</td>
                            <td>{ (e.end == undefined ? 0 : e.end) - e.start }</td>
                        </tr>;
                    })}
                  </tbody>
                </table>

            </div>);
}